import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Immutable from 'immutable';

import { Link } from '@bibliocommons/base-links';

import cardShape from 'app/shapes/cardShape';

import './ContentCardImage.scss';

function renderPlaceholder() {
  return <span />;
}

export default function ContentCardImage({ card, handleClick, compact }) {
  const [usePlaceholder, setUsePlaceholder] = useState(false);

  const handleError = () => setUsePlaceholder(true);

  function renderImage() {
    const image = card.getIn(['image', 'bwCardImage11'], Immutable.Map());

    return (
      <Link
        href={card.get('url')}
        dataKey="card-link"
        className="card-link"
        handleClick={() => handleClick(card)}
        aria-hidden
      >
        <img
          src={image.get('url')}
          alt={image.get('altText') || ''}
          aria-hidden={!image.get('isInformative')}
          onError={handleError}
          loading="lazy"
        />
      </Link>
    );
  }

  const classNames = cn('cp-content-card-image', {
    'content-card-image--compact': compact
  });

  return <div className={classNames}>{usePlaceholder ? renderPlaceholder() : renderImage()}</div>;
}

ContentCardImage.propTypes = {
  card: cardShape.isRequired,
  compact: PropTypes.bool,
  handleClick: PropTypes.func
};
